import React from 'react'

function LinkIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" 
        width="25" 
        height="13" 
        viewBox="0 0 25 13" 
        fill="none">
        <path d="M2.375 6.5C2.375 4.277 4.1125 2.47 6.25 2.47H11.25V0H6.25C2.8 0 0 2.912 0 6.5C0 10.088 2.8 13 6.25 13H11.25V10.53H6.25C4.1125 10.53 2.375 8.723 2.375 6.5ZM7.5 7.8H17.5V5.2H7.5V7.8ZM18.75 0H13.75V2.47H18.75C20.8875 2.47 22.625 4.277 22.625 6.5C22.625 8.723 20.8875 10.53 18.75 10.53H13.75V13H18.75C22.2 13 25 10.088 25 6.5C25 2.912 22.2 0 18.75 0Z" fill="#454C53"/>
    </svg>
  )
}

export default LinkIcon;